// useDigestData.ts
import { useState, useEffect } from 'react';
import { Digest, useGenerateDigestLazyQuery } from '../../../gql/types';
import { useSearchParams } from 'react-router-dom';
import { useSyncStatus } from '../../../contexts/SyncStatusProvider';
import { LOCAL_MODE } from 'config/local';

export const useDigestData = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [showDataLoadingScreen, setShowDataLoadingScreen] = useState(false);
    const [shouldClearSearchParams, setShouldClearSearchParams] = useState(false);
    const { checkSyncStatus, setCheckSyncStatus } = useSyncStatus();

    const [fetchDigest, { data, loading }] = useGenerateDigestLazyQuery({
        onCompleted: async () => {
            setShowDataLoadingScreen(false);
            setShouldClearSearchParams(true);
        },
        onError: (err) => {
            console.error("Error fetching digest:", err);
        },
        fetchPolicy: LOCAL_MODE ? "no-cache" : "cache-and-network",
    });

    useEffect(() => {
        const loadDigest = async () => {
            if (searchParams.has("refetch")) {
                setShowDataLoadingScreen(true);
                return;
            }

            if (showDataLoadingScreen) {
                return;
            }

            setShowDataLoadingScreen(true);
        };

        loadDigest();

    }, [searchParams]);

    useEffect(() => {
        if (shouldClearSearchParams) {
            setSearchParams({});
            setShouldClearSearchParams(false);
        }
    }, [setSearchParams, shouldClearSearchParams]);

    useEffect(() => {
        if (checkSyncStatus) {
            setShowDataLoadingScreen(true);
            setCheckSyncStatus(false);
        }
    }, [setCheckSyncStatus, checkSyncStatus]);

    const dataLoadingCallback = () => {
        setShowDataLoadingScreen(false);
        fetchDigest();
    };

    return {
        currentDigest: data?.generateDigest ?? null,
        loading,
        showDataLoadingScreen,
        dataLoadingCallback,
    };
};
